import { Card, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import RoleAccess from "../../function/RoleAccess";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FileUploadModal } from "../../../components/uploadDialog/FileUploadModal";
import { useMutation } from "@apollo/client";
import {
  deleteCustomerMaster,
  getAllCustomermaster,
  uploadCustomerMaster,
} from "./customerData";
import Swal from "sweetalert2";
import { useLoading } from "../../../context/LodingContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import TableComponents from "../../../../src/components/tabel/index";

const CustomerMaster = () => {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [UpdateFile] = useMutation(uploadCustomerMaster);
  const { userId } = useAuthData();
  const [uploadStatus, setUploadStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [dataCount, setDataCout] = useState({
    pageCount: 0,
    itemCount: 0,
  });
  const [searchValue, setSearchValue] = useState("");

  const CustomerMasterListTable = {
    columns: [
      {
        header: "Customer Code",
        accessorKey: "customerCode",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Customer Name",
        accessorKey: "customerName",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Customer Category",
        accessorKey: "customerCategory",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Created By",
        accessorKey: "createdBy",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Created On",
        accessorKey: "createdOn",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Action",
        accessorKey: "action",
        cell: (props) => <>{props?.getValue()}</>,
      },
    ],

    rows: customerData.map((c, i) => ({
      sno: i + 1,
      customerCode: c?.customerCode,
      customerName: c?.customerName,
      customerCategory: c?.customerCategory,
      status: c?.status,
      createdBy:c?.user?.employeeName,
      createdOn: c?.createdAt?.slice(0, 10),

      action: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <RoleAccess
            modelName="Customer Master Screen"
            component="ViewCustomerMaster"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/master/customer-master/view-customer-master`, {
                  state: { type: "view", customerId: c.id },
                })
              }
            />
          </RoleAccess>

          <RoleAccess
            modelName="Customer Master Screen"
            component="UpdateCustomerMaster"
          >
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/master/customer-master/edit-customer-master`, {
                  state: { type: "edit", customerId: c.id },
                })
              }
            />
          </RoleAccess>

          <RoleAccess
            modelName="Customer Master Screen"
            component="DeleteCustomerMaster"
          >
            <DeleteIcon
              fontSize="small"
              className="actionIcon"
              onClick={() => handleDelete(c?.id)}
            />
          </RoleAccess>
        </div>
      ),
    })),
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const res = await request(BASEURL, deleteCustomerMaster, {
            id: id,
          });

          const success = res?.deleteCustomerMaster?.success;
          const message = res?.deleteCustomerMaster?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              fetchCustomerData();
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  const handleExcelUpload = async (file) => {
    setUploadStatus(false);
    setCirleLoading(true);
    try {
      const response = await UpdateFile({
        variables: {
          file: file,
          userId: userId,
        },
        context: { hasUpload: true },
      });

      const success = response?.data?.uploadCustomerMaster?.success;

      const message = response?.data?.uploadCustomerMaster?.message;
      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          fetchCustomerData();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "File upload failed!",
        text: error.message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };
  useEffect(() => {
    fetchCustomerData();
  }, [pagination, searchValue]);

  const fetchCustomerData = async () => {
    setIsLoading(true);
    try {
      const res = await request(BASEURL, getAllCustomermaster, {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
        search: searchValue,
      });
      const success = res?.getAllCustomermaster?.success;
      if (success) {
        setCustomerData(res?.getAllCustomermaster?.data);
        setDataCout({
          itemCount: res?.getAllCustomermaster.totalCount,
          pageCount: res?.getAllCustomermaster.totalPages,
        });
      } else {
        setCustomerData([]);
        setDataCout({
          pageCount: 0,
          itemCount: 0,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUploadClick = () => {
    setUploadStatus(false);
    setTimeout(() => setUploadStatus(true), 0);
  };

  const handleChange = (value) => {
    setSearchValue(value);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Customer Master List
                </MaterialTypography>
              </Stack>
              <RoleAccess
                modelName="Customer Master Screen"
                component="UploadCustomerMaster"
                
              >
                <label
                  className="container-btn-file"
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={() => handleUploadClick()}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Upload File
                </label>
              </RoleAccess>

              <RoleAccess
                modelName="Customer Master Screen"
                component="CreateCustomerMaster"
              >
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/master/customer-master/add-customer-master", {
                      state: { type: "add" },
                    })
                  }
                >
                  Customer Master
                </MaterialButton>
              </RoleAccess>
            </Stack>
          }
        />
        {uploadStatus && (
          <FileUploadModal
            key={Date.now()}
            status={uploadStatus}
            onClose={() => setUploadStatus(false)}
            onSubmit={(file) => handleExcelUpload(file)}
          />
        )}

        <>
          <TableComponents
            rows={CustomerMasterListTable?.rows}
            columns={CustomerMasterListTable?.columns}
            pagination={pagination}
            setPagination={setPagination}
            pageCount={dataCount.pageCount}
            onChange={handleChange}
            recordCount={dataCount.itemCount}
            isLoading={isLoading}
            isSearch={true}
          />
        </>
      </Card>
    </DashboardLayout>
  );
};
export default CustomerMaster;
